@if (!isOnline) {
  <app-product-overview></app-product-overview>
}
@if (isOnline) {
  <app-online-product-overview></app-online-product-overview>
}
